(function ($) {
  $(document).ready(function ($) {
    if ($(".index-product").length) {
      // Swatch Hover Select
      if ($(".product-swatches").length) {
        var currentSelected = $(".product-swatches .swatch-name .selected-swatch-title").text();

        $(".product-swatches .swatch-item").hover(
          function () {
            $(".product-swatches .swatch-name .selected-swatch-title").text($(this).attr("data-swatch-title"));
          },
          function () {
            $(".product-swatches .swatch-name .selected-swatch-title").text(currentSelected);
          }
        );
      }

      // Thumbnails Click Down Arro
      var thumbScroller = $(".product__thumbs__holder")[0];

      if (thumbScroller.scrollHeight > thumbScroller.clientHeight) {
        $(".product__images").addClass("overscroll-thumbs");
      }
      $(".down-arrow-next").on("click", function () {
        var element = $(".product__thumbs__holder");
        element.animate(
          {
            scrollTop: element.prop("scrollHeight"),
          },
          800
        );
      });

      /*****************************************************************
       * Add Class for Double Variants ONLY
       *****************************************************************/
      if ($(".product__selectors").length) {
        var selectWrapper = $(".product__selectors .selector-wrapper");
        var productSelector = $(".product__selectors");

        if (selectWrapper.length > 1) {
          productSelector.addClass("multiple-variants");
        }
      }
    }
  });
})(jQuery);
